{
  "id": "campaign-140",
  "name": "Mower Soccer",
  "seed": "campaign:140",
  "generatorVersion": 3,
  "level": 140,
  "biome": "stadium",
  "startDir": "N",
  "mowerRule": {
    "kind": "exclude",
    "mowers": ["fairway"]
  },
  "rows": [
    "r............r",
    "..............",
    "..............",
    "..............",
    "..............",
    "..............",
    "..............",
    "....a....a....",
    "..............",
    "..............",
    ".....a..a.....",
    "..............",
    "..............",
    "..............",
    "..............",
    ".......S......",
    "..............",
    "r............r"
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 13
    }
  ],
  "critters": [],
  "soccer": {
    "target": 3,
    "halfTiles": 127,
    "stars": {
      "goals": 5,
      "mowed": 0.3
    }
  },
  "par": {
    "reel": 3810,
    "push": 3302,
    "selfPropelled": 3048,
    "tractor": 2540,
    "zeroTurn": 2159
  }
}
